import { CartLinesUpdateEvent } from '@shopify/events';
import '@theme/theme-drawer';

let pending = false;
document.addEventListener('click', event => {
  const trigger = event.target.closest('.vy-bag');
  const drawer = document.getElementById('cart-drawer');
  if (!trigger || !drawer || typeof drawer.open !== 'function') return;
  event.preventDefault();
  drawer.open();
});

document.addEventListener('submit', async event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.ve form[action*="/cart/add"], .vy-commerce form[action*="/cart/add"]')) return;
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  event.preventDefault();
  if (pending || !form.reportValidity()) return;
  pending = true;
  const buttons = [...form.querySelectorAll('[type="submit"]'), ...document.querySelectorAll(`[form="${form.id}"][type="submit"]`)];
  buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
  let message = form.querySelector('.vy-cart-status');
  if (!message) {
    message = document.createElement('p');
    message.className = 'vy-cart-status';
    message.setAttribute('role', 'status');
    form.append(message);
  }
  message.textContent = '';
  const data = new FormData(form);
  data.set('sections', [...new Set([...document.querySelectorAll('cart-items-component')].map(component => component.dataset.sectionId).filter(Boolean))].join(','));
  data.set('sections_url', window.location.pathname);
  const root = window.Shopify.routes.root;
  let added = false;
  try {
    const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || form.dataset.cartError);
    added = true;
    const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error(form.dataset.cartRefreshError);
    const cart = await cartResponse.json();
    const promise = Promise.resolve({cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {sections: result.sections, items: cart.items, itemCount: cart.item_count, source: 'veyana-product-form', didError: false}});
    form.dispatchEvent(new CartLinesUpdateEvent({action: 'add', context: 'product', lines: [{merchandiseId: String(data.get('id')), quantity: Number(data.get('quantity')) || 1}], promise}));
    message.textContent = form.dataset.cartAdded;
    drawer.open();
  } catch (error) {
    message.textContent = added ? form.dataset.cartRefreshError : (error.message || form.dataset.cartError);
    if (added) drawer.open();
  } finally {
    pending = false;
    buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
  }
});
